import React from 'react';
import axios from '../axios';

const SectionSubject = ({
  event,
  setEvent,
  bodyText,
  titleText,
  setBodyText,
  setTitleText,
  bodyError,
  titleError,
  setTitleError,
  // updateTitleContent,
  updateTextContent,
  onFocusScrollForAndroid,
  userAgent,
}) => {
  const [lastUpdateTime, setLastUpdateTime] = React.useState(0);

  // イベント説明を20秒以上間隔をおいてDBに自動保存
  const updateTextContentToDB = (text) => {
    const currentTime = Date.now();
    if (currentTime - lastUpdateTime >= 20000) {
      updateTextContent && updateTextContent(text);
      setLastUpdateTime(currentTime);
    } else {
      return;
    }
  };

  // const updateTitleContentToDB = (title) => {
  //   const currentTime = Date.now();
  //   if (currentTime - lastUpdateTime >= 20000) {
  //     updateTitleContent && updateTitleContent(title);
  //     setLastUpdateTime(currentTime);
  //   } else {
  //     return;
  //   }
  // };

  const generateDefaultImage = React.useCallback((titleText) => {
    const body = JSON.stringify({
      event_id: event.id,
      event_title: titleText,
    });
    axios.post('/api/event/generate_default_image', body).then((response) => {
      setEvent((prev) => ({
        ...prev,
        main_image_url_medium_strict: response.data.main_image_url,
      }));
    });
  }, [event.id, setEvent]);

  const onBlurTitle = React.useCallback((titleText) => {
    //画像がない場合、デフォルト画像を自動生成
    if (
      event.main_image_url_medium_strict == undefined &&
      !!titleText &&
      15 <= titleText.length &&
      titleText.length <= 100
    ) {
      generateDefaultImage(titleText);
    }
  }, [event.main_image_url_medium_strict, generateDefaultImage]);

  const onTitleError = React.useCallback(() => {
    if (!titleText || titleText.length < 15 || titleText.length > 100) {
      setTitleError('タイトルは15文字以上100文字以内で入力してください。');
    } else {
      setTitleError('');
    }
  }, [titleText, setTitleError]);

  return (
    <section id="event_details">
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6">
          <div className="row justify-content-between align-items-center">
            <p className="col-5 text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              イベント名
              <span className="text-fz-14px text-fw-bold text-orange mb-2 mt-1 ml-2 d-inline-block">
                必須
              </span>
            </p>
          </div>
          {titleError && (
            <p className="text-danger text-fz-small mt-0 mb-0">{titleError}</p>
          )}
          <textarea
            id="title"
            className={`p-1 w-100 form-control ${
              titleError ? 'border border-danger' : ''
            }`}
            onBlur={() => {
              onBlurTitle(titleText);
              // updateTitleContentToDB(titleText);
            }}
            value={titleText}
            onChange={(e) => {
              setTitleText(e.target.value);
              setEvent((prev) => ({ ...prev, title: e.target.value }))
              // updateTitleContentToDB(e.target.value);
            }}
            placeholder="たのしいハロウィンパーティーイベント"
            onFocus={(e) => onFocusScrollForAndroid(e)}
            height='auto'
          />
        </div>
        <div className="container col-md-8 col-lg-6 px-3 py-3">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-1 d-inline-block">
            イベントの説明
            <span className="text-fz-14px text-fw-bold text-orange mb-2 mt-1 ml-2 d-inline-block">
              必須
            </span>
          </p>
          {bodyError && (
            <p className="text-danger text-fz-small mt-0 mb-0">{bodyError}</p>
          )}
          <textarea
            id="body"
            className={`p-1 w-100 form-control ${
              bodyError ? 'border border-danger' : ''
            }`}
            onBlur={() => {
              updateTextContentToDB(bodyText);
            }}
            onClick={() => onTitleError()}
            placeholder={
              'イベントの概要、楽しめる点、注意点など\n例）みんなでハロウィーンパーティしましょう！仮装できる人はぜひ仮装してきてください！\n渋谷駅近くのレンタルスペースで行います！\n基本的にみんな一人参加なので、お気軽に参加してくださいね！\n\n●当日の流れ\n18:00 待ち合わせ場所に集合\n18:10 班分けしてみんなで買い出し\n19:00 パーティ開始\n21:00 解散\n\n●持ち物\n仮装するための衣装（する人だけでOK）\n\n●注意事項\n勧誘などはNGです。'
            }
            value={bodyText}
            onChange={(e) => {
              setBodyText(e.target.value);
              updateTextContentToDB(e.target.value);
            }}
            onFocus={(e) => onFocusScrollForAndroid(e)}
            rows={userAgent === 'android' ? '8' : '12'}
          />
        </div>
      </div>
    </section>
  );
};

export default SectionSubject;
